var _ellipse, _path, _circle, _rect, _rect2, _path2, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2184,
    height: 2159,
    viewBox: "0 0 2184 2159",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 997,
    cy: 1079.5,
    rx: 997,
    ry: 1079.5,
    fill: "url(#paint0_linear_1715_12657)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2161.89 545.329C1359.08 1014.11 965.885 1103.86 331 1061.89",
    stroke: "#E5CC82",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1265.5,
    cy: 971.5,
    r: 12.5,
    fill: "#E5CC82"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2058.01,
    y: 246.507,
    width: 30,
    height: 2278,
    transform: "rotate(62.9394 2058.01 246.507)",
    fill: "#1A1C3A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1896.81,
    y: 254.134,
    width: 40,
    height: 2067,
    transform: "rotate(62.9394 1896.81 254.134)",
    fill: "#E5CC82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2177.98 1511.13C1282.91 1762.35 879.79 1750.06 276 1549.36",
    stroke: "#1A1C3A",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1659.31,
    cy: 1638.13,
    r: 11,
    transform: "rotate(14.6038 1659.31 1638.13)",
    fill: "#1A1C3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1715_12657",
    x1: -232.633,
    y1: 756.891,
    x2: 1292.49,
    y2: 1255.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBg);
export default __webpack_public_path__ + "static/media/home_bg.b560f0d8267cf56ce85139f695897840.svg";
export { ForwardRef as ReactComponent };